// src/store/authStore.ts
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface AuthUser {
   id?: string;
   name: string;
   email: string;
   verified?: boolean;
   role?: string;
   // Tabs a staff member may access in the admin panel. Empty/absent for
   // admins (they see everything) and regular operators.
   staffPermissions?: string[];
   /** Profile photo (header menu → Profile). */
   avatar?: string | null;
}

interface AuthState {
   token: string | null;
   user: AuthUser | null;
   isAuthenticated: boolean;
   setAuth: (token: string, user: AuthUser) => void;
   clearAuth: () => void;
}

const useAuthStore = create<AuthState>()(
   persist(
      (set) => ({
         token: null,
         user: null,
         isAuthenticated: false,
         setAuth: (token, user) => {
            if (
               user &&
               typeof user === 'object' &&
               typeof user.email === 'string' &&
               typeof user.name === 'string'
            ) {
               set({ token, user, isAuthenticated: true });
            } else {
               console.log('Rejected invalid user object:');
               // console.warn('Rejected invalid user object:', user);
            }
         },
         clearAuth: () =>
            set({ token: null, user: null, isAuthenticated: false }),
      }),
      {
         name: 'x-user',
         storage: createJSONStorage(() => localStorage),
      }
   )
);

export default useAuthStore;
